import React, { FC } from 'react'

import { CoreDayReservableArea } from '../../../common/validations/contractDayReservableAreasSchema'
import { UserMetadata } from '../../../common/validations'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import { useAPIGetContractDayReservableAreasSuspense } from 'api/apiHooks/useAPIGetContractDayReservableAreas'
import { useAPIGetUserMetadataSuspense } from 'api/apiHooks/useAPIGetUserMetadata'

export const DayReservableAreasDataLoader: FC<{
  include?: 'all' | 'own'
  children: (
    areas: CoreDayReservableArea[],
    userMetadata: UserMetadata
  ) => React.ReactNode
}> = ({ include = 'all', children }) => {
  const { currentContractId } = useCurrentContract()
  const { data } = useAPIGetContractDayReservableAreasSuspense(
    currentContractId,
    include
  )
  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  const areas: CoreDayReservableArea[] = data?.dayReservableAreas ?? []
  return <>{children(areas, userMetadata)}</>
}
